module.exports = __webpack_public_path__ + "img/22_1.9a797d47.png";